/**
 * SyncCoordinator - Manages periodic cloud syncing during gameplay
 *
 * Simplified to just handle:
 * - Cloud save callback registration (SaveManager → CloudSaveManager)
 * - Periodic cloud sync during active gameplay (60s interval)
 */

export class SyncCoordinator {
    constructor(config) {
        this.saveManager = config.saveManager;
        this.cloudSaveManager = config.cloudSaveManager;
        this.accountManager = config.accountManager;
        this.gameState = config.gameState;

        // Active gameplay sync interval (60 seconds)
        this._activeGameplaySyncInterval = null;
        this._activeGameplaySyncIntervalMs = 60 * 1000;
    }

    /**
     * Initialize - register cloud save callback
     */
    async initialize() {
        console.log('[SyncCoordinator] Initializing...');

        // Register cloud save callback so SaveManager triggers CloudSaveManager
        if (this.saveManager && this.cloudSaveManager) {
            this.saveManager.registerCloudSaveCallback((state, force) => {
                this.cloudSaveManager.queueSync(state, force);
            });
        }

        console.log('[SyncCoordinator] Initialized');
    }

    /**
     * Start periodic cloud sync during active gameplay (60s interval)
     */
    startActiveGameplaySync() {
        if (!this.accountManager?.isLinked() || !this.cloudSaveManager) {
            return;
        }

        if (this._activeGameplaySyncInterval) {
            return; // Already running
        }

        console.log('[SyncCoordinator] Starting active gameplay sync (every 60s)');

        this._activeGameplaySyncInterval = setInterval(async () => {
            try {
                await this.cloudSaveManager.forceLocalToCloud(this.gameState.state);
            } catch (err) {
                console.warn('[SyncCoordinator] Active gameplay sync failed:', err);
            }
        }, this._activeGameplaySyncIntervalMs);
    }

    /**
     * Stop periodic cloud sync during active gameplay
     */
    stopActiveGameplaySync() {
        if (this._activeGameplaySyncInterval) {
            clearInterval(this._activeGameplaySyncInterval);
            this._activeGameplaySyncInterval = null;
            console.log('[SyncCoordinator] Stopped active gameplay sync');
        }
    }

    /**
     * Cleanup
     */
    dispose() {
        this.stopActiveGameplaySync();
    }
}
